import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"; // Import the Arrow icon
import { useMediaQuery } from "@mui/material";

import NewRequestIcon from "assets/images/icons/NewRequest.png";
import PhoneIcon from "assets/images/icons/Phone.png";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import backgroundImage from "assets/images/bg-dashboard.png";
// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";
import Projects from "layouts/dashboard/components/Projects";
import MDTypography from "components/MDTypography";
//User Data
import { UserContext } from "context";
// ENV Values
const apiUrl = process.env.REACT_APP_API_URL;

function Dashboard() {
  const { sales, tasks } = reportsLineChartData;
  const [stats, setStats] = useState({ total_users: 0, total_events: 0 });
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  // Detect if the screen is mobile-sized
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(`${apiUrl}/dashboard.php`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        if (response.ok) {
          setStats(data);
        } else {
          console.error("Failed to fetch stats:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchStats();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <MDBox position="relative" mb={5}>
        {/* Background Image Section */}
        <MDBox
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="relative"
          borderRadius="xl"
          sx={{
            minHeight: { xs: "8.75rem", sm: "18.75rem" },
            backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
              `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "50%",
            overflow: "hidden",
          }}
        >
          {/* Left Button with Phone Icon */}
          {user.isAdmin ? undefined : (
            <MDBox position="absolute" top="16px" left="16px">
              <MDButton
                display="flex"
                justifyContent={isMobile ? "center" : "space-between"} 
                color="secondary"
                mt={0.2}
                alignItems="center"
                onClick={() => navigate("/app/meeting")}
              >
                <MDBox
                  component="img"
                  src={PhoneIcon}
                  alt="NewRequest"
                  width="24px"
                  ml={-1}
                  mr={isMobile ? -1 : 1} 
                  my={-4}
                  sx={{
                    cursor: "pointer",
                  }}
                />
                {!isMobile && (
                  <MDTypography
                    variant="h7"
                    fontWeight="medium"
                    textTransform="white"
                    color="white"
                    mt={0.2}
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    PRENOTA CALL
                  </MDTypography>
                )}
              </MDButton>
            </MDBox>
          )}

          {/* Right Button with Arrow Icon */}
          {user.isAdmin ? undefined : (
            <MDBox position="absolute" top="16px" right="16px">
              <MDButton
                display="flex"
                justifyContent={isMobile ? "center" : "space-between"}
                alignItems="center"
                onClick={() => navigate("/app/eventRequest")}
                sx={{
                  backgroundColor: "#1E1E1E",
                  mx: isMobile ? -1 : 0,
                  border: "2px solid #4CAF50",
                  padding: "12px 20px",
                  fontSize: "1.1rem"
                }}
              >
                <MDBox
                  component="img"
                  src={NewRequestIcon}
                  alt="NewRequest"
                  width="24px"
                  ml={-1}
                  mr={isMobile ? -1 : 1}
                  my={-4}
                  sx={{
                    cursor: "pointer",
                  }}
                />
                {/* Conditionally show text for non-mobile screens */}
                {!isMobile && (
                  <MDTypography
                    variant="h7"
                    fontWeight="medium"
                    textTransform="primary"
                    color="primary"
                    mt={0.2}
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    NUOVA RICHIESTA
                  </MDTypography>
                )}
              </MDButton>
            </MDBox>
          )}
          {/* Centered Header */}
          <MDTypography
            variant="h1"
            color="white"
            sx={{
              my: 2,
              px: { xs: 6 },
              textAlign: "center",
            }}
          >
            La tua Dashboard
          </MDTypography>
        </MDBox>
        <MDBox
          sx={{
            mt: { xs: 4, sm: -12 },
            mx: { xs: 0, sm: 3 },
            pt: 2,
            px: { xs: 0, sm: 2 },
          }}
        >
          <Grid container spacing={7}>
            <Grid item xs={12} lg={12} xl={12}>
              <Projects type={"deadlines"} />
            </Grid>
            <Grid item xs={12} lg={6} xl={6}>
              <Projects type={"event"} />
            </Grid>
            <Grid item xs={12} lg={6} xl={6}>
              <Projects type={"permissions"} />
            </Grid>
            <Grid item xs={12} lg={6} xl={6}>
              <Projects type={"eventValidation"} />
            </Grid>
            <Grid item xs={12} lg={6} xl={6}>
              <Projects type={"waitingForPayment"} />
            </Grid>

            <Grid item xs={12} lg={6} xl={6}>
              <Projects type={"eventArchive"} />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;

